const colors = {
  neonGreen: '#00FF00',
  black: '#000000',
  tealBlue: '#005D50',
  transparentGray: '#F0F0F0CC',
  transparentWhite: 'rgba(255, 255, 255, 0.5)'
};

export default colors;
